import { render, staticRenderFns } from "./PageSetDZ.vue?vue&type=template&id=62d842c4&scoped=true&"
import script from "./PageSetDZ.vue?vue&type=script&lang=js&"
export * from "./PageSetDZ.vue?vue&type=script&lang=js&"
import style0 from "./PageSetDZ.vue?vue&type=style&index=0&id=62d842c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d842c4",
  null
  
)

export default component.exports